// extracted by mini-css-extract-plugin
export default {"point":"StepPoint_point__hggig","active":"StepPoint_active__tqvxV","loading":"StepPoint_loading__wmy-v","complete":"StepPoint_complete__1RXlx"};